module.exports = new __parcel__URL__("default-merchant-icon.6068d068.png").toString();